import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";
import {MediaGalleryFragment} from "./fragments/MediaGallery";
export const GET_VIEWED_INTEREST_FIELDS_BY_SCHOOL = gql`
  query GetViewedInterestFieldsBySchool {
    getViewedInterestFieldsBySchool {
      id
      interestName
      value
    }
  }
`;
